var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('p',[_vm._v("企财通inapp_jsbridge测试 20230817-10:48")]),_c('a',{on:{"click":_vm.toAbout}},[_vm._v("to about")]),_c('HelloWorld'),_c('p',[_vm._v(_vm._s(_vm.uaInfo))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }